import { Modal, Spin } from 'antd'
import Styles from '../css/vehicleModals.module.scss'
import { LoadingOutlined } from '@ant-design/icons';


const VehicleLoadingModal = (props:any) => {  
    return ( 
        <div>
            <Modal title="Basic Modal" centered destroyOnClose={true} width={400} open={props.isModalOpen} onOk={props.handleOk} onCancel={props.handleCancel}  className={Styles.customModal}>
                <div className={Styles.modalContentVerification}>
                   <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}><Spin indicator={<LoadingOutlined  style={{ fontSize: 50,color:'black' }} spin />} /></div>
                   {/* <div style={{textAlign:'center'}} className={Styles.title}>loading data</div> */}
                   <div style={{textAlign:'center',whiteSpace:'pre-line'}} className={Styles.descThree}>loading data</div>
               </div>
            </Modal>   
        </div>
     );
}
 
export default VehicleLoadingModal;